import { createSlice } from '@reduxjs/toolkit';


export interface IState {
  templateData: [];
  templateNumber:number;
  mobileDevice:boolean;
  draftTemplate:boolean;
  merchantTemplateId:number;
  newTemplate:boolean;
}
const initialState: IState = {
    templateData: [],
    templateNumber: 0,
    mobileDevice:false,
    draftTemplate:false,
    merchantTemplateId:0,
    newTemplate:false,
};

const createTemplate = createSlice({
  name: 'create-template',
  initialState,
  reducers: {
    setTemplateReducer(state, action) {
      state.templateData = action.payload;
    },
    setTemplateNumberReducer(state, action) {
      state.templateNumber = action.payload;
    },
    setMobileDeviceReducer(state, action) {
      state.mobileDevice = action.payload;
    },
    setDraftTemplateReducer(state, action) {
      state.draftTemplate = action.payload;
    },
    setMerchantTemplateIdReducer(state, action) {
      state.merchantTemplateId = action.payload;
    },
    setNewTemplateReducer(state, action) {
      state.newTemplate = action.payload;
    }
  },
});

export const { setTemplateReducer, setTemplateNumberReducer, setMobileDeviceReducer, setDraftTemplateReducer,setMerchantTemplateIdReducer,setNewTemplateReducer } = createTemplate.actions;
export default createTemplate.reducer;
